export const messages = {
  en: {
    housekeepingFeeType: {
      queryCondition: 'Query Conditions',
      feeType: 'Fee Category',
      typeName: 'Type Name',
      typeNamePlaceholder: 'Please enter type name',
      typeNameRequired: 'Type name cannot be empty',
      typeNameMaxLength: 'Type name is too long',
      isShow: 'Is Display',
      isShowPlaceholder: 'Please select display status',
      isShowRequired: 'Display status cannot be empty',
      createTime: 'Create Time',
      remark: 'Remark',
      remarkPlaceholder: 'Optional, please enter remarks',
      addTitle: 'Add Fee Category',
      editTitle: 'Edit Fee Category',
      deleteTitle: 'Delete Confirmation',
      deleteConfirm: 'Are you sure to delete this fee category?',
      deleteSuccess: 'Delete successfully'
    }
  },
  zh: {
    housekeepingFeeType: {
      queryCondition: '查询条件',
      feeType: '费用大类',
      typeName: '类型名称',
      typeNamePlaceholder: '请输入类型名称',
      typeNameRequired: '类型名称不能为空',
      typeNameMaxLength: '类型名称太长',
      isShow: '是否展示',
      isShowPlaceholder: '请选择是否展示',
      isShowRequired: '是否展示不能为空',
      createTime: '创建时间',
      remark: '备注',
      remarkPlaceholder: '选填，请填写备注',
      addTitle: '添加费用大类',
      editTitle: '修改费用大类',
      deleteTitle: '删除确认',
      deleteConfirm: '确定删除该费用大类吗？',
      deleteSuccess: '删除成功'
    }
  }
}